module.exports = __webpack_public_path__ + "static/media/footer-logo.fe9240e2.png";